import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, } from 'rxjs';
import { LoggedUserModel } from './logged-user.model';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
//import firebase from 'firebase/app';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class AuthenticationService {

  loggedUserSubject: BehaviorSubject<LoggedUserModel>;
  loggedUser: LoggedUserModel;

  userImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAO2ElEQVR4Xu1dCViO2Rf/tQtZkswwwtgmk2UsMUXZImuoLCE7TbZkUOhvmMWWsaeMfWyNPYSxm8QohrFlyTIKkaJU2v/PeWeaB33f9+7v932m8zw99Tzd95xz7+8959577rnnNcjKyipECenMCBiUAKIzWDCKlACiW3iUAKJjeOgPIIWFQH5BAbKyc/Ey4w1epGUh+VUm83dWdh4KCgthZGiA0mYmqGhhDqty5qhUrjTKlTZDKVNjGBkZwkDXRl+FPjrrsgoKCpH6+g2u3k/CsUv38HtcIl6kZ4KA4UsGBgaoVskCre1s0LZxTdjaWKGsuSkMDXQPIp0CJC+/AHGPkrH1xFUcv3wfObn5fMeec3uynO4t68HDyRY1rCvA0FA3wNE6IPTGJ6W+xsqIGPx6MR45efKBoA4tAsejTQMMcWmMcmXMOIMqR0OtAUIu6cq9JCz45SxuJSQLckVSDwi5MMfPq2OSeyvUrFIR2vBoigNSWFiIS3efImjDCTxJeS31mErGz65mZcwZ0h41q1RQFBhFAXmY9BLT1hzDrYQXkg2c3IycGtpg1uC2sLQwl1uUchvD7Nw8BO88h12/3QRZiL6RiZEhxrnZY2CHhjAyNJRVfdkt5NqDZxi7PBJpmdmydkQJ5jWqlMfKcd1QzcpCNnGyAUIbtZCIGKw7/Af0zybUjzdZyKzBzsySWY5JXxZAMrNzMWbJflx78Fy2N0nbjLu1rItvBreFsZG0LkxyQGjlNGjebqSkZ2l7zGSX36BGZYRO7A4Lc1PJZEkKyN3EFAyavxvZMu6wJeu5RIw+siyLn6f2hlX50pJwlAwQijX5LD0giVL6xsTMxBi/zPSAjXV50apLAkjs7ccYtXi/aGX0mQFFlHcEeeITq3KiuiEakITkNPT833a93F+IGjkVD1uYm+Ho/EEgixFKogDJeJODrjO3Ii1DO3sMis/SOQctRWkJSntOihjTuYm2qE5VS4TP8BAcPRYMSH5BIfp/vxN3H6co2ncKANauagkPp8/RtWV9VCpf+p2DJ9r/JCanYW/UDeyLjsPjF2mKBy47NauN+SM7ChoXwYDM2x6F8NPXBQkV8hBZAYEw2dMRFqW5h8ifpKRj9qYTOPPnQ0Xd6rdD2qF7q3q8uyoIkN9vJsBn2UHewoQ+0Lj2Rwib5IbyZUoJZYF7T1Lhs3gfHj1/JZgHnwfpOPnQ9wNRuUIZPo/xP1PPeJOLjtM24U1OHi9BQhqTe5rc1xHDXZsJebzYM+Rmg9YfY9yZEuEcWnHtm9Of11ExbwuZHHYEJy4/kGSANDEhMML83dDarobkstYeuohFO6IUmVvGu9ljuOsXnPvAC5Cr959hyII9sr9dtGL6yb8XHGUAo2hk1kTGYtGOs5wHSmhDinUdX+DNZL9wIc6AkLl3m7kFSakZXPiKahM4wAnenbi/VUKE0blM4Jqj2Bd9U8jjvJ6xr18NYX7dOT3DGZAjsXcRsPY4J6ZiGrWoXw2bAjzEsOD8bG5ePlwDNuLxi3TOzwhpSBa/e1Y/5jiYjTgBQpst58kbQGF1OcnU2AgXQnxE7XT56hf36DncZ21jEu3kpHqfVGI2jGzECZDIC3cwY/0JNl6i/z+1XxsMc20qmg9fBpNCInE45g7fx3i1p6gCxbpoU6uJWAGhN8dl2s+yn29QcC521Veyn1mrGgxyWS5T1stuJc3rVcVPk3qIA4RWVt4L9vB6G4Q0HtW1Ofw9HYU8KskzwxfuxrkbjyThpY4JZUeeXDhE44qL1UIorE7hdTmJzPlS2FgmKVpb9HtcAobO3yW7eMqO9OvTSq0cjYBQNLf1pPWyK0lZ6lFLR8kuR5MASmFtPGqF7DpQHO7MoqHCANlzNg5zNp+WXcku9nXx41ddZZfDJsDedxXSs3LYmon+/7ZAd3xmY6WSj0YL6TVrOx4+kz8YF+zjim4t64vuqFgG3205hS3Hrohlw/p8lxZ18MPwDvwAoeDhlxPXsjIX24Dubhya640aHDZNYmWxPX/y8n34Lo1gayb6/5SWSuEUVaTWQpRaXdE5R0yID8zNTER3VCyDB09T0SVwk1g2rM9T4JRZbam4+qAWkOAd0dhy4iorc7ENzEyMcHn1OLFsJHk+9XUWHMavloQXG5N5Izqgc/M6xZqpBaRz4GY8eyl/ILFMKVNmQ6gLlJ6ZDfuxoYqoou6YVyUgFLtqNWGtIskC/1VAqlcuh4g5A7hZCGWROH+9QZE3xdTECFd0xWWlZ8FhgjIui/odvWQEc3P4bVJpIXSFYPB8+cMlpAhN6hdW+qB0Ke1P6nTu3m26/JM69ZuZ2IOLh1FUAnIkNh4Ba48pYiG07D34w2DU+qiiIvI0CTl+KR7jliuXDrvnm+JnJCoBCd0fi7DIi4oN0NyRndDL0VYxeeoEBa0/jp1nrimmxzLfLmjT0IbdZdHZB52BKEUdm9bG8vHcjjjl1KmpTwhTKUIpCuzfGn2dP2cHZOSPEbh454lSejGlMKKXjVZMnipBdA+yyeiViuowqmtT+PZowQ5Iv+924naicjdl6cz5Uqh2w+8xtxLhPW+nooAMaGeHqX3fPQNSOYf0/iYcD5JeKqrcmO4t4OfuoKjMt4WNDN6Ds9f/UlQ+VY+Y4dWG3ULcZ/+Ce09TFVWOlr20/JX72rGqTj1NeY0OX6+T/Qj3fdmeTg0wfQAHQGgPQnsRpcmnewtM1IKVjFq0F1HXHirdXaa2yvunhypdlt+qwzj9p/IKknWcXzGGKZ2kFF2Jf4r+34UrJe4dORN7t8TQTk3YXdb88LPYfkq59fjbGtnaVMbu2V6KDBCVf3L2X4OXr98oIu99IXRIRYdVb5NKCwk/dR3zwqO0oiQJ9elhj4l9vpRVPqWS+i7dj1NX7ssqRxPzTVN7oWGtKuyAnLuRAN/lyt3/eF9pCrfRGburfV3ZBosSrSnhWltEfTw8dxCs37s/otJCHj17hZ6ztmtLV0YuKbxQprN2bYNB/aMo79klw4ulzaoEhC7+O0xcq/gysJilGAAjujTHJA8HXpde1L1JlFztFxKJE3/c0+rLRsLLlzHDqeDi6UAqAaH0UQJEVyoy1P7YEiF+PWBjzZ49rmqkKY36SvwT+C6JYApr6gI1+rQKNk7pVUwVtUe441ceQtQ1ZXeutOxVd6WZwiuuLerB38MB1azKgcL2bERlBG8nJmP2xpO4HK8+Nkfug+6/KEkUw6JYVjGvoK7U+IHztxG08aTsOhIIlDQ2rlcrNKtbFf2+Dcd9lihB1UoW6N26AZwb1UR16wp/1+X9Z1Ap2/LekxQcvnAHkRdusy5p23/xKX4Y4YKjF+OZSZ7mT7mvJtCgUimOutUqcQfk+csMdArcLBsgFOH1dmkCrw6N30k+Jj8/ZvE+XonPdG2MLIYsgmvRADIwr/aNMWOg8zvWRhVSww7EICL6JuiCqxxE92DOLR2hsriAWpdFnXPwWwcKS0tJ9HZP6dcGLs1qq41b0R5h9cFYrNx7Hrn50ldloBywuSNd0Lm5+mU1zZ9bj19hwHmVIe28Q4Wctwa6qxxWjamks38+jb3RcZLgQZcep3s5o6eDLedKbAnP0zBhxQHQLScpLjjROXbrhjUQPMaVc/EBsrjQ/TGMO5PqKvhMrzZwb9OAPyDxj1Pg8e0OUYCQK6EKDDMHtgVlWvAlmmpj4hIwd9sZ3H6ULMi/0/zS4rNPGB3YbjCp04+sxH/VIZy7/peoW8g0Z0YvHQ5yW6pIo4WQ22o7ZQPSM4VlhFPlhVC/nmhS52O+OBRrTxZCdUvCT10FJSMkJqerdae0/qKJvtbHlujxZX24Odgyp5JiiXQ4cD4OdPYu1JU3sKmMLYF91KrCemEnZH8Mfoq8xLsvDWpYY1OAOygRTmqigcnJywOdY5AV01cS6H6HuakxrCuWRZ1qlkyFNxMj/hbJRVcqz+E9dyeepvIvBL3U1xVODdUXQ2AFJPNNLpwmr+e1Tvd0tsOcoarT7bl0WB/aUHbnkPm7cOkO99tltDunJGtNeyhWQGhw+GSheLVvhKDB7fRhTEXrSC59yIJdiL2VyInXtH6O6N/WTmNbToBQ9QbX6ex7EqdGNZmqPf8lIlfpFrQFdJVBE1GWf9Ti4axlZTkBQoK+Xv0rjv+h/uyA7gmeWTxScCU1fQaR5rAOU9Zp/N7JhF72GNaZvVwIZ0BepGXCJWCzyiJg5BNP/ziCd20ofQbhfd2PXryLCStUnyHRwua3xcM4fXKJMyCkwOJd57FJxR08N0dbzBvZ6UMaX959ofiXx+xtuPmweDXvhaNc0LHpp5x48gKE1t6dAja/U1ifdr8XQ321esecU08VaETfy+o7592DPdqI7gzy5CydFyDE9dzNBIxddvDf3apdTWvsmFX84glnDT6ghmQlzXxC/g2x0Mt6ZO4gXlWveQNC40cfZaHvRRFR6JpC4SX09wjMWHsUu6NuMH9P6tMK3i6NeQ2NIECycnLRfeY25qzh7LLRqFBWeHFKXtrqQeNr95PgOWc7PqtuhW3TVUd0NXVDECDEkG4bDQveh+jlo7WS/qmr2KRnZaOd/zrmHjrtPfiSYEBIEF1ZcGxYi6/MD7o9zSN3/koSXAhBFCA0siYmJjCSKYinj8jl5uYiP1/4txhFA0KDZmZmxinpQB8HmI/OBAQBIoYkAaQElL8/nJybI+zc6G0AJQPkvwyKVGDQGEoKCDE0NTWFoczf+hPjEqR+Vgo3JZuFFDE2NjYG/XzoJHYCVzU+kltIkRCyErKWD5Eo8SInO1uWz1/IBgjjDw0MGFC4pH3qC3AFBQXIkWDyVtdfWQH50FyYHC7qfWAUAaTIWmgTqY8TvtQTtyZvoBggb88tBIw+uDFKaSX3pOQXrhUHpAgYCrfQSkwXgSEAyD3RfKE0aQ2Qty2GgNEFV0YAEBBKWoTW5hC2N40shayGfpS0Ghp8miPy8iggqOylHUX3IWwAaJzY/gGHrEYOyyFLIBDERGXF9E+nJnUhHSGLKbKgor+LVm7q+BW5HfpNABT9CJGv5DNan0OU7Kw+yCoBRMdQKgGkBBAdGwEdU6fEQnQMkP8Do7eTz5t0pEkAAAAASUVORK5CYII=';

  public authState: Observable<firebase.User>;

  constructor(private firebaseAuth: AngularFireAuth, private db: AngularFirestore, private router: Router) {

    this.loggedUserSubject = new BehaviorSubject(this.loggedUser);

    this.firebaseAuth.authState.subscribe(firebaseUser => {
      if (firebaseUser !== null) {
          this.checkSystemUserLoaded().then(() => {
            this.loggedUserSubject.next(this.loggedUser);
          });
      } else {
          // user logged out
          if (this.loggedUser) { 
            this.loggedUser = null; 
            this.loggedUserSubject.next(null);
            this.router.navigate(['authentication/signin'])
          }
      }
    });    
  }

  public checkSystemUserLoaded() {
    return new Promise<void>((resolve, reject) => {
        if (this.loggedUser) {
            resolve();
        } else {
            try {
                const firebaseUser = this.firebaseAuth.auth.currentUser;

                firebaseUser.getIdTokenResult(true).then (result => {

                  if (result.claims.isSuperUser && result.claims.isSuperUser == true) {
                    this.loggedUser = new LoggedUserModel();
                    this.loggedUser.id = result.claims.user_id;
                    this.loggedUser.name = result.claims.name;
                    this.loggedUser.email = result.claims.email;
                    this.loggedUser.image = this.userImage;
                    resolve();
                  } else {
                    this.logout().subscribe(() => {
                      reject(null);
                    });              
                  }                  

                  // this.db.collection('agency').doc(result.claims.agencyId).collection('users').doc<LoggedUserModel>(firebaseUser.uid).ref.get().then(doc => {
                  //   if (doc.exists){
                  //     this.loggedUser = doc.data() as LoggedUserModel;
                  //     this.loggedUser.id = doc.id;
                  //     this.loggedUser.agencyId = result.claims.agencyId;

                  //     resolve();
                  //   } else {
                  //     this.logout().subscribe(() => {
                  //       resolve();
                  //     });
                  //   }

                  // }).catch(err => {
                  //     this.logout().subscribe(() => {
                  //         reject(err);
                  //     });
                  // });                  
              });


            } catch (err) {
                this.logout().subscribe(() => {
                    reject(err);
                });
            }
        }
    });
  }    

  login(email: string, password: string) {
    return new Promise<any>((resolve, reject) => {

      if (this.loggedUser) {
          // log the user out first
          this.logout().subscribe(() => {

            this.firebaseAuth.auth.signInWithEmailAndPassword(email, password).then(res => {

              const firebaseUser = this.firebaseAuth.auth.currentUser;

              firebaseUser.getIdTokenResult(true).then (result => {

                if (result.claims.isSuperUser && result.claims.isSuperUser == true) {
                  this.loggedUser = new LoggedUserModel();
                  this.loggedUser.id = result.claims.user_id;
                  this.loggedUser.name = result.claims.name;
                  this.loggedUser.email = result.claims.email;
                  this.loggedUser.image = this.userImage;

                  this.loggedUserSubject.next(this.loggedUser);
                  resolve(this.loggedUser);                  

                } else {
                  this.logout().subscribe(() => {
                    reject(null);
                  });              
                }                

                // this.db.collection('agency').doc(result.claims.agencyId).collection('users').doc<LoggedUserModel>(firebaseUser.uid).ref.get().then(doc => {
                //   if (doc.exists){
                //     this.loggedUser = doc.data() as LoggedUserModel;
                //     this.loggedUser.id = doc.id;
                //     this.loggedUser.agencyId = result.claims.agencyId;
                    
                //     this.loggedUserSubject.next(this.loggedUser);
                //     //this.setProfileImage();
                //     resolve(this.loggedUser);
                //   } else {
                //     reject();
                //   }
                // });

              });

            }).catch(err => {
              reject(err);
            });
          });
      } else {
        this.firebaseAuth.auth.signInWithEmailAndPassword(email, password).then(res => {

          const firebaseUser = this.firebaseAuth.auth.currentUser;

          firebaseUser.getIdTokenResult(true).then (result => {

            if (result.claims.isSuperUser && result.claims.isSuperUser == true) {
              this.loggedUser = new LoggedUserModel();
              this.loggedUser.id = result.claims.user_id;
              this.loggedUser.name = result.claims.name;
              this.loggedUser.email = result.claims.email;
              this.loggedUser.image = this.userImage;

              this.loggedUserSubject.next(this.loggedUser);
              resolve(this.loggedUser); 
                     
            } else {
              this.logout().subscribe(() => {
                reject(null);
              });              
            }
            // this.db.collection('agency').doc(result.claims.agencyId).collection('users').doc<LoggedUserModel>(firebaseUser.uid).ref.get().then(doc => {
            //   if (doc.exists){
            //     this.loggedUser = doc.data() as LoggedUserModel;
            //     this.loggedUser.id = doc.id;
            //     this.loggedUser.agencyId = result.claims.agencyId;

            //     this.loggedUserSubject.next(this.loggedUser);
            //     //this.setProfileImage();
            //     resolve(this.loggedUser);
            //   } else {
            //     reject();
            //   }
            // });

          });

        }).catch(err => {
            reject(err);
        });
      }
    });
  }  

  logout(): Observable<any> {
    this.loggedUser = null;
    // your log out logic should go here
    this.loggedUserSubject.next(null);
    this.firebaseAuth.auth.signOut();

    return of(true);
  }
}
